import { Slide } from "@jelly/lesson";
import { task as task02 } from "../../../../../task/course-02/lesson-10/task-02";

const task: Slide = {
  title: `Which among the following sounds would you expect to have the highest sharpness value? `,
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
